import { render } from "./Gists.vue?vue&type=template&id=59513bca"
import script from "./Gists.vue?vue&type=script&lang=js"
export * from "./Gists.vue?vue&type=script&lang=js"

import exportComponent from "/home/user/leandro-gomez.github.io/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__